import { render, staticRenderFns } from "./Exponentialekvation2.vue?vue&type=template&id=54d52cca&scoped=true&"
import script from "./Exponentialekvation2.vue?vue&type=script&lang=js&"
export * from "./Exponentialekvation2.vue?vue&type=script&lang=js&"
import style0 from "./Exponentialekvation2.vue?vue&type=style&index=0&id=54d52cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d52cca",
  null
  
)

export default component.exports